export interface Permissao {
    id?: string;
    nome: string;
    descricao?: string;
    categoria?: string;
}

export class PermissaoUtils {
    static temPermissao(permissoesPerfil: Permissao[], permissoesNecessarias: string[]): boolean {
        const nomesPermissoesPerfil = permissoesPerfil.map((p) => p.nome);
        return permissoesNecessarias.every((pNecessaria) => nomesPermissoesPerfil.includes(pNecessaria));
    }

    static setCategoriaForPermissoes(permissoes: Permissao[]): Permissao[] {
        permissoes?.forEach((p) => {
            if (p.nome.includes('processo')) {
                p.categoria = 'Processo';
            }
            if (p.nome.includes('sala-espera')) {
                p.categoria = 'Processo';
            }

            if (p.nome.includes('banca')) {
                p.categoria = 'Bancas';
            }
            if (p.nome.includes('membro')) {
                p.categoria = 'Bancas';
            }

            if (p.nome.includes('atividade')) {
                p.categoria = 'Cronograma';
            }
            if (p.nome.includes('cronograma')) {
                p.categoria = 'Cronograma';
            }

            if (p.nome.includes('perfil')) {
                p.categoria = 'Usuário';
            }
            if (p.nome.includes('permiss')) {
                p.categoria = 'Usuário';
            }
            if (p.nome.includes('usuario')) {
                p.categoria = 'Usuário';
            }

            if (p.nome.includes('unidade')) {
                p.categoria = 'Unidade';
            }

            if (p.nome.includes('candidato')) {
                p.categoria = 'Candidato';
            }

            if (p.nome.includes('pessoa')) {
                p.categoria = 'Pessoa';
            }

            if (p.nome.includes('composicao')) {
                p.categoria = 'Composição';
            }
        });

        return permissoes;
    }
}

export enum PermissaoEnum {
    CONCLUIR_CRONOGRAMA = 'concluir-cronograma',
    ATUALIZAR_LISTA_CANDIDATO_INTEG = 'atualizar-lista-candidato-integ',
    CADASTRAR_DATA_DE_BANCA = 'cadastrar-data-de-banca',
    CADASTRAR_PESSOA = 'cadastrar-pessoa',
    UPLOAD_CANDIDATO = 'upload-candidato',
    ALTERAR_USUARIO = 'alterar-usuario',
    ATUALIZAR_MEMBROS = 'atualizar-membros',
    ATUALIZAR_DATA_DE_BANCA = 'atualizar-data-de-banca',
    DEFINIR_BANCA = 'definir-banca',
    ATUALIZAR_SALA_DE_BANCA = 'atualizar-sala-de-banca',
    FINALIZAR_PROCESSO = 'finalizar-processo',
    CONSULTAR_UNIDADE = 'consultar-unidade',
    VALIDAR_MEMBROS = 'validar-membros',
    CONSULTAR_PROCESSO = 'consultar-processo',
    CONSULTAR_SALA_DE_BANCA = 'consultar-sala-de-banca',
    ATUALIZAR_UNIDADE = 'atualizar-unidade',
    CONSULTAR_CANDIDATO_BANCA = 'consultar-candidato-banca',
    CONSULTAR_CANDIDATO = 'consultar-candidato',
    ATUALIZAR_SALA_ESPERA = 'atualizar-sala-espera',
    DELETAR_ATIVIDADE = 'deletar-atividade',
    CONVOCAR_BANCA = 'convocar-banca',
    CONSULTAR_CRONOGRAMA = 'consultar-cronograma',
    CADASTRAR_PROCESSO = 'cadastrar-processo',
    CONSULTAR_SALA_ESPERA = 'consultar-sala-espera',
    CONSULTAR_MEMBROS = 'consultar-membros',
    CADASTRAR_ATIVIDADE = 'cadastrar-atividade',
    CADASTRAR_SALA_ESPERA = 'cadastrar-sala-espera',
    CADASTRAR_UNIDADE = 'cadastrar-unidade',
    ATUALIZAR_PROCESSO = 'atualizar-processo',
    CADASTRAR_BANCA = 'cadastrar-banca',
    ATUALIZAR_ATIVIDADE = 'atualizar-atividade',
    REMOVER_MEMBROS = 'remover-membros',
    CONSULTAR_ATIVIDADE = 'consultar-atividade',
    DELETAR_CANDIDATO_INTEG = 'deletar-candidato-integ',
    CONSULTAR_PESSOA = 'consultar-pessoa',
    ATUALIZAR_PESSOA = 'atualizar-pessoa',
    CADASTRAR_MEMBROS = 'cadastrar-membros',
    CONSULTAR_USUARIO = 'consultar-usuario',
    CONSULTAR_BANCA = 'consultar-banca',
    ATUALIZAR_CANDIDATO_INTEG = 'atualizar-candidato-integ',
    CONSULTAR_PAPEL_MEMBROS = 'consultar-papel-membros',
    CADASTRAR_LISTA_CANDIDATO_INTEG = 'cadastrar-lista-candidato-integ',
    CONSULTAR_DATA_DE_BANCA = 'consultar-data-de-banca',
    ATIVAR_MEMBRO = 'ativar-membro',
    DESATIVAR_MEMBRO = 'desativar-membro',

    ADMINISTRADOR = 'administrador',

    // Permissões faltantes
    AUSENCIA_CANDIDATO = 'ausencia-candidato',
    VINCULAR_CANDIDATO = 'vincular-candidato',
    CONSULTAR_VOTACAO = 'consultar-votacao',
    DESVINCULAR_CANDIDATO = 'desvincular-candidato',
    FECHAR_VOTACAO = 'fechar-votacao',
    VOTAR_CANDIDATO = 'votar-candidato',
    ABRIR_VOTACAO = 'abrir-votacao',
    CONSULTAR_BANCAS_INTEG = 'consultar-bancas-integ',
    CONVOCAR_CANDIDATO = 'convocar-candidato',

    DOWNLOAD_VIDEOS = 'download-videos',
    UPLOAD_VIDEOS = 'upload-videos',

    PERMISSAO_TESTE = 'permissão-inexistente-para-testar',

    FINALIZAR_BANCA = 'finalizar-banca',
    CONSULTAR_RECURSO = 'consultar-recurso',

    ENVIAR_EMAIL_CANDIDATO = 'enviar-email-candidato',
    AUDITORIA = 'auditoria',
    CANCELAR_BANCA = 'cancelar-banca',
    FECHAMENTO_BANCA = 'fechamento-banca',
    FINALIZAR_BANCA_INTEGRACAO = 'finalizar-banca-integracao',
    ABRIR_INTEGRACAO_PROCESSO_CANDIDATOS = 'abrir-integracao-processo-candidatos',
    FINALIZAR_INTEGRACAO_PROCESSO_CANDIDATOS = 'finalizar-integracao-processo-candidatos',
    EDITAR_CANDIDATO = 'editar-candidato',

    SOLICITAR_CONTA_SERVICO = 'solicitar-conta-servico',
    APROVAR_CONTA_SERVICO = 'aprovar-conta-servico',
    VISUALIZAR_CONTA_SERVICO = 'visualizar-conta-servico',

    CONSULTAR_COMPOSICAO = 'consultar-composicao',
    CADASTRAR_COMPOSICAO = 'cadastrar-composicao',
    ATIVAR_COMPOSICAO = 'ativar-composicao',
    DESATIVAR_COMPOSICAO = 'desativar-composicao',
    DELETAR_COMPOSICAO = 'deletar-composicao',

    DAC = 'dac'
}
